import {
  Modal,
  Form,
  Input,
  Button,
  Radio,
  Select,
  Tabs,
  Row,
  Col,
} from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import paymentMethodApi from '../../api/paymentMethod';
import IntlMessage from '../../components/IntlMessage';
import operatorsApi from '../../api/operators';
import opPaymentMethodsApi from '../../api/op-payment-method';
import { field_payment_method, payment_params } from '../../utils/constant';
import _ from 'lodash';
import { useMounted } from '../../hooks/useMounted';

const OpPaymentMethodForm = (props) => {
  const { isModalOpen, setIsModalOpen, currentData, onModalClose, onRefresh } =
    props;
  const [operatorOption, setOperatorOption] = useState([]);
  const [paymentOption, setPaymentOption] = useState([]);
  const [operatorSelected, setOperatorSelected] = useState();
  const [paymentSelected, setPaymentSelected] = useState();

  const { isMounted } = useMounted();

  const fetch = useCallback(async () => {
    try {
      if (isMounted) {
        const filter = {
          page: 1,
          limit: 9999,
          order_by: 'id',
          order_dir: 'DESC',
          keyword: '',
        };
        const operator = await operatorsApi.getAll(filter);
        const payment = await paymentMethodApi.getAll(filter);

        const list_operator = operator.data.map((item) => {
          return {
            label: item.short_name || item.id,
            value: item.id,
          };
        });
        setOperatorOption(list_operator);
        const list_payment = payment.data.map((item) => {
          return {
            label: item.display || item.id,
            value: item.id,
          };
        });
        setPaymentOption(list_payment);
      }
    } catch (err) {
      console.log(err);
    }
  }, [isMounted]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const initialValues = {
    ...currentData,
    status: currentData && currentData.status ? 1 : 0,
    is_on_userapp: currentData && currentData.is_on_userapp ? 1 : 0,
    is_on_operatorapp: currentData && currentData.is_on_operatorapp ? 1 : 0,
    fee: currentData && currentData.fee ? currentData.fee : '',
    operator: currentData && currentData.operator ? currentData.operator : '',
    is_fee_default:
      currentData && currentData.is_fee_default
        ? currentData.is_fee_default
        : '',
    payment_method:
      currentData && currentData.payment_method
        ? currentData.payment_method
        : '',
    wave_template_sms:
      currentData && currentData.wave_template_sms
        ? currentData.wave_template_sms
        : '',
    suffix_userapp:
      currentData && currentData.suffix_userapp
        ? currentData.suffix_userapp
        : '',
    suffix_operatorapp:
      currentData && currentData.suffix_operatorapp
        ? currentData.suffix_operatorapp
        : '',
    meta_data: (() => {
      try {
        const parsedField = currentData?.field
          ? JSON.parse(currentData.field)
          : null;

        if (parsedField && Array.isArray(parsedField)) {
          return field_payment_method.map((key) => ({
            [key]: _.get(_.keyBy(parsedField, 'code'), `${key}.value`, ''),
          }));
        } else {
          return field_payment_method.map((key) => ({
            [key]: parsedField?.[key] || '',
          }));
        }
      } catch (error) {
        return field_payment_method.map((key) => ({ [key]: '' }));
      }
    })(),
    sms_data:
      currentData && currentData.params
        ? payment_params.map((key) => ({
            [key]:
              currentData && currentData.params
                ? JSON.parse(currentData.params)[key] || null
                : null,
          }))
        : payment_params &&
          payment_params.map((key) => ({
            [key]: null,
          })),
  };

  const onChangeOperator = (value) => setOperatorSelected(value);

  const onChangePayment = (value) => setPaymentSelected(value);

  const onFinish = (values) => {
    console.log('Success:', values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        let data = {
          ...values,
          operator: operatorSelected,
          payment_method: paymentSelected,
        };
        const field = [];
        let combinedObject = {};
        let combinedObjectSMS = {};
        currentData &&
          data.sms_data.forEach((item) => {
            Object.keys(item).forEach((key) => {
              combinedObjectSMS[key] = item[key];
            });
          });
        if (combinedObjectSMS) {
          data = {
            ...data,
            params: JSON.stringify(combinedObjectSMS),
          };
        }
        console.log('data.meta_data', data.meta_data);
        currentData &&
          data.meta_data.forEach((item) => {
            if (_.isArray(JSON.stringify(currentData.field))) {
              const key = Object.keys(item);
              const value = item[key];
              combinedObject[key] = value;
            } else {
              Object.keys(item).forEach((key) => {
                combinedObject[key] = item[key];
              });
            }
          });
        console.log('dcombinedObject', combinedObject);
        if (combinedObject) {
          field.push(combinedObject);
          data = {
            ...data,
            field: JSON.stringify(combinedObject),
          };
        }
        if (currentData) {
          delete values.operator_id;
          delete values.payment_method_id;

          await opPaymentMethodsApi.update(currentData.id, data);
          setIsModalOpen(false);
          onRefresh();
        } else {
          let addData = {
            ...values,
          };
          if (values.meta_data) {
            const arrToObj = Object.assign({}, ...values.meta_data);
            addData = {
              ...addData,
              field: JSON.stringify(arrToObj),
            };
          }

          await opPaymentMethodsApi.create(addData);
          setIsModalOpen(false);
          onRefresh();
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const tabItems = [
    {
      label: <IntlMessage id="global.op_payment_method" />,
      key: '1',
      children: (
        <>
          <Form.Item
            label="Operator"
            name="operator_id"
            rules={[
              {
                required: currentData && currentData.operator ? false : true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Select
              defaultValue={
                currentData && currentData.operator
                  ? currentData.operator.display
                  : ''
              }
              style={{
                width: 240,
              }}
              onChange={onChangeOperator}
              options={operatorOption}
            />
          </Form.Item>

          <Form.Item
            label="Payment Method"
            name="payment_method_id"
            rules={[
              {
                required:
                  currentData && currentData.payment_method ? false : true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Select
              defaultValue={
                currentData && currentData.payment_method
                  ? currentData.payment_method.id
                  : ''
              }
              style={{
                width: 240,
              }}
              onChange={onChangePayment}
              options={paymentOption}
            />
          </Form.Item>

          <Form.Item label="Wave template sms" name="wave_template_sms">
            <Input placeholder="Input Title" />
          </Form.Item>

          <Form.Item
            label="Fee"
            name="fee"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>

          {/* <Form.Item
            label="Fee default"
            name="is_fee_default"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Input />
          </Form.Item> */}

          <Form.Item label="Suffix Operator App" name="suffix_operatorapp">
            <Input />
          </Form.Item>

          <Form.Item label="Suffix User App" name="suffix_userapp">
            <Input />
          </Form.Item>

          {currentData ? (
            <Form.Item
              label="Status"
              name="status"
              rules={[
                {
                  required: true,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}>
              <Radio.Group name="radiogroup">
                <Radio value={1}>
                  <IntlMessage id="global.active" />
                </Radio>
                <Radio value={0}>
                  <IntlMessage id="global.inactive" />
                </Radio>
              </Radio.Group>
            </Form.Item>
          ) : null}

          <Form.Item
            label="On User App"
            name="is_on_userapp"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Radio.Group name="radiogroup">
              <Radio value={1}>
                <IntlMessage id="global.active" />
              </Radio>
              <Radio value={0}>
                <IntlMessage id="global.inactive" />
              </Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="On Operator App"
            name="is_on_operatorapp"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Radio.Group name="radiogroup">
              <Radio value={1}>
                <IntlMessage id="global.active" />
              </Radio>
              <Radio value={0}>
                <IntlMessage id="global.inactive" />
              </Radio>
            </Radio.Group>
          </Form.Item>
        </>
      ),
    },
    {
      label: <IntlMessage id="global.sms_settings" />,
      key: '4',
      forceRender: true,
      children: (
        <>
          <Form.List name="sms_data">
            {(fields, { add }) => {
              return (
                <>
                  {fields.map((field, index) => {
                    const fieldName = payment_params[index];
                    if (fieldName === 'sender_id') {
                      return (
                        <Form.Item
                          label={<IntlMessage id={`global.${fieldName}`} />}
                          labelCol={{ span: 4 }}
                          name={[index, fieldName]}
                          key={field.key}>
                          <Input style={{ width: 500 }} />
                        </Form.Item>
                      );
                    } else {
                      return (
                        <Form.Item
                          label={<IntlMessage id={`global.${fieldName}`} />}
                          labelCol={{ span: 4 }}
                          name={[index, fieldName]}
                          key={field.key}>
                          <Input.TextArea
                            autoSize={{ minRows: 6 }}
                            style={{ width: 500 }}
                          />
                        </Form.Item>
                      );
                    }
                  })}
                </>
              );
            }}
          </Form.List>
        </>
      ),
    },
    {
      label: <IntlMessage id="global.setting" />,
      key: '2',
      forceRender: true,
      children: (
        <>
          <Form.List name="meta_data">
            {(fields, { add }) => {
              const filterFields = fields.map((item, index) => {
                return {
                  ...item,
                  fieldName: field_payment_method[index],
                };
              });

              console.log('filterFields', filterFields);
              return (
                <>
                  {filterFields.map((field, index) => {
                    const fieldName = field_payment_method[index];
                    console.log('fieldName', fieldName);

                    return (
                      <Form.Item
                        key={field.key}
                        label={<IntlMessage id={`global.${fieldName}`} />}
                        name={[index, fieldName]}>
                        <Input />
                      </Form.Item>
                    );
                  })}
                </>
              );
            }}
          </Form.List>
        </>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Modal
        title={
          currentData ? (
            <IntlMessage id="global.edit" />
          ) : (
            <IntlMessage id="global.add" />
          )
        }
        open={isModalOpen}
        onCancel={onModalClose}
        width={'50%'}
        footer={[
          <>
            <Button key="back" type="default" onClick={onModalClose}>
              {<IntlMessage id="global.cancel" />}
            </Button>
            <Button key="back" type="primary" onClick={handleOk}>
              {<IntlMessage id="global.save" />}
            </Button>
          </>,
        ]}>
        <Form
          name="basic"
          labelAlign="left"
          {...layout}
          className="ml-20"
          initialValues={initialValues}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off">
          <Tabs defaultActiveKey="1" items={tabItems} />
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default OpPaymentMethodForm;
